/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { 
    ThunkResult } from "./actionResultTypes";
import { 
    Action as ReportConfirmAction,
    ActionType as ReportConfirmActionType, 
    IFetchIsConfirmedReport,
    IFetchIsConfirmedReportSuccess,
    IFetchIsConfirmedReportFail,
    IEditIsConfirmedReport,
    IEditIsConfirmedReportSuccess,
    IEditIsConfirmedReportFail,
    IFetchConfirmedReports,
    IFetchConfirmedReportsSuccess,
    IFetchConfirmedReportsFail,
} from "../actionTypes/reportConfirmActionType";
import { toastError, toastSuccess, toastWarning } from '../../services/toasters';
import { httpGenerator } from '../../services';
import { 
    IIsCoordinatorConfirmedReport as IsCoordinatorConfirmedReport, 
    IRequestCoordinatorReportConfirm, 
    IRequestIsCoordinatorConfirmedReport, 
    IConfirmedReport,
    IProjectManagerConfirmed
} from '../../models/reportConfirm';
import { SingleResponseType } from '../../models/singleResponseType';
import { AxiosResponse } from 'axios';
import { 
    Action as ContractInfoAction,
    ActionType as ContractInfoActionType, 
    IEditContractInfo,
    IProjectManagerConfirmSuccess,
    IEditContractInfoFail,
} from '../actionTypes/contractInfoActionTypes';
import { MultiResponseType } from '../../models/multiResponseType';


export const ProjectManagerConfirm = (request: IProjectManagerConfirmed): ThunkResult<void> => async (dispatch: Dispatch<ContractInfoAction>) => { 
    dispatch<IEditContractInfo>({ 
        type: ContractInfoActionType.EDIT_CONTRACTINFO 
    });
    const authToken = sessionStorage.getItem("token")

    try {
        const response: AxiosResponse<SingleResponseType<string>> = 
            await httpGenerator(authToken!).post(`reportConfirm/projectManagerReportConfirm/`, request);
        dispatch<IProjectManagerConfirmSuccess>({ 
            type: ContractInfoActionType.EDIT_PROJECTMANAGERCONFIRM_SUCCESS, 
        });
        if(response.data.data === "Err:01")
            toastWarning("اخطار: ابتدا باید تمامی گزارشات تائید شوند");

    } catch (err: any) {
        dispatch<IEditContractInfoFail>({ 
            type: ContractInfoActionType.EDIT_CONTRACTINFO_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا: تائید پروژه در ماه جاری انجام نشد");
    }
};

export const GetCoordinatorConfirmedReport = (request: IRequestIsCoordinatorConfirmedReport): ThunkResult<void> => async (dispatch: Dispatch<ReportConfirmAction>) => { 
    dispatch<IFetchIsConfirmedReport>({  
        type: ReportConfirmActionType.FETCH_COORDINATORCONFIRM
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<SingleResponseType<IsCoordinatorConfirmedReport>> = 
            await httpGenerator(authToken!).post(`reportConfirm/isCoordinatorConfirmedReport/`, request);
        dispatch<IFetchIsConfirmedReportSuccess>({
            type: ReportConfirmActionType.FETCH_COORDINATORCONFIRM_SUCCESS,
            payload: response.data
        });

    } catch(err: any) {
        dispatch<IFetchIsConfirmedReportFail>({
            type: ReportConfirmActionType.FETCH_COORDINATORCONFIRM_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const CoordinatorConfirmReport = (request: IRequestCoordinatorReportConfirm): ThunkResult<void> => async (dispatch: Dispatch<ReportConfirmAction>) => { 
    dispatch<IEditIsConfirmedReport>({ 
        type: ReportConfirmActionType.EDIT_COORDINATORCONFIRM 
    });
    
    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<SingleResponseType<IsCoordinatorConfirmedReport>> = 
            await httpGenerator(authToken!).post(`reportConfirm/coordinatorReportConfirm/`, request);
        dispatch<IEditIsConfirmedReportSuccess>({ 
            type: ReportConfirmActionType.EDIT_COORDINATORCONFIRM_SUCCESS, 
            payload: response.data
        });
        toastSuccess("گزارش ماه جاری با موفقیت تائید شد");

    } catch (err: any) {
        dispatch<IEditIsConfirmedReportFail>({ 
            type: ReportConfirmActionType.EDIT_COORDINATORCONFIRM_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا: تائید گزارش در ماه جاری انجام نشد");
    }
};

export const GetConfirmedReports = (contractId: string, dateID: string): ThunkResult<void> => async (dispatch: Dispatch<ReportConfirmAction>) => { 
    dispatch<IFetchConfirmedReports>({  
        type: ReportConfirmActionType.FETCH_CONFIRMREPORTS
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<MultiResponseType<IConfirmedReport>> = 
            await httpGenerator(authToken!).get(`reportConfirm/confirmedReports/${contractId}/${dateID}`);
        dispatch<IFetchConfirmedReportsSuccess>({
            type: ReportConfirmActionType.FETCH_CONFIRMREPORTS_SUCCESS,
            payload: response.data
        });

    } catch(err: any) {
        dispatch<IFetchConfirmedReportsFail>({
            type: ReportConfirmActionType.FETCH_CONFIRMREPORTS_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}